import API from "../api/backend/contractParent";
import { COMMON_CONSTANT, KEY } from "../constants/common.const";
import { showMessage } from "../constants/utils";

// this function help to check exactly type of value
// typeOf([]) => 'Array'
// typeOf(new Date()) => 'Date'
// typeOf(new Function()) => 'Function'

export function typeOf(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}

export function formatNumber(value) {
  if (value == null) {
    return "";
  }
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const handleDownloadAttachment = async(filePath) => {
  if (!filePath) {
    console.error("File path is required for downloading attachment");
    return;
  }

  // Get file name from filePath
  const fileName = filePath.split("/").pop();
  const fileNameEncode = encodeURIComponent(fileName)

  // handle error if resApi is not a promise
  API.downloadAttachment(fileNameEncode).then((res) => {
    if (res.status !== 200) {
      throw new Error("Failed to download attachment");
    }
    let fileName = res.headers["content-disposition"].split("filename=")[1];
    // decode URL fileName.
    fileName = decodeURIComponent(fileName);
    const blob = new Blob([res.data]);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.target = "_blank";
    link.download = fileName;
    link.click();
  })
  .catch((error) => {
    console.error("Error downloading attachment:", error);
    showMessage(KEY.ERROR, COMMON_CONSTANT.MESSAGE_FILE_NOT_FOUND);
  });
};